declare namespace $ {

	export class $yuf_number_range_string extends $mol_string {
		step( ): number
		min( ): number
		max( ): number
		type( ): string
		keyboard( ): string
		attr( ): ({ 
			'title': ReturnType< $yuf_number_range_string['hint'] >,
		})  & ReturnType< $mol_string['attr'] >
		field( ): ({ 
			'step': ReturnType< $yuf_number_range_string['step'] >,
			'min': ReturnType< $yuf_number_range_string['min'] >,
			'max': ReturnType< $yuf_number_range_string['max'] >,
		})  & ReturnType< $mol_string['field'] >
	}
	
}

//# sourceMappingURL=string.view.tree.d.ts.map